module.exports = __webpack_public_path__ + "resources/img/img_expand_v2.8f6347ee1c9e4bf5206ddbd97e4ee308.png";